import React from 'react';
import SystemLabel from '../../../../system/SystemLabel/SystemLabel';
import SectionTagHelperImage from '../assets/images/section_tags_helper.png'
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';



export default function MediaCard() {
    return (
        <Card style={{ maxWidth: '345px' }}>
                <CardMedia
                    src={SectionTagsHelpInfo}
                    title="SectionTagsHelpInfo"
                />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        <SystemLabel name="SectionTagInfoTitle" />
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        <SystemLabel name="SectionTagsHelp" />
                    </Typography>
                </CardContent>
        </Card>
    );
}
export const SectionTagsHelpInfo = () => {
    return (
        <Card style={{ maxWidth: '345px' }}>
            <CardActionArea>
                <img src={SectionTagHelperImage} />
                <CardContent>
                    <Typography gutterBottom variant="h5" component="h2">
                        <SystemLabel name="SectionTagInfoTitle" />
                    </Typography>
                    <Typography variant="body2" color="textSecondary" component="p">
                        <SystemLabel name="SectionTagsHelp" />
                    </Typography>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}